module.exports = __webpack_public_path__ + "static/img/vouchers10010.74cf8a95.png";